export default function ReadingNumbersMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Reading the Numbers</div>
      <div className="platform-mock-body">
        <div className="mock-metrics-grid">
          <div className="mock-metric-card" style={{ borderColor: 'rgba(245,158,11,0.3)' }}>
            <div className="mock-metric-label">Win Rate</div>
            <div className="mock-metric-value">82.1%</div>
            <div style={{ fontSize: '0.5625rem', color: '#f59e0b', marginTop: '0.25rem' }}>High win rate, but check avg trade size</div>
          </div>
          <div className="mock-metric-card" style={{ borderColor: 'rgba(239,68,68,0.3)' }}>
            <div className="mock-metric-label">Max Drawdown</div>
            <div className="mock-metric-value red">-42.3%</div>
            <div style={{ fontSize: '0.5625rem', color: '#ef4444', marginTop: '0.25rem' }}>Extreme &mdash; would you hold through this?</div>
          </div>
          <div className="mock-metric-card">
            <div className="mock-metric-label">Profit Factor</div>
            <div className="mock-metric-value amber">0.94</div>
            <div style={{ fontSize: '0.5625rem', color: '#f59e0b', marginTop: '0.25rem' }}>Below 1.0 = losing money overall</div>
          </div>
        </div>
        <div style={{ marginTop: '0.75rem', padding: '0.5rem 0.75rem', background: 'rgba(245,158,11,0.06)', border: '1px solid rgba(245,158,11,0.15)', borderRadius: '0.375rem' }}>
          <span style={{ fontSize: '0.6875rem', color: '#f59e0b', fontWeight: 600 }}>This strategy wins often but loses big. High win rate masks poor risk-adjusted performance.</span>
        </div>
      </div>
      <div className="platform-mock-caption">High win rate does not always mean a good strategy &mdash; context is everything.</div>
    </div>
  );
}
